exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "trip-tile-div {\n  position: relative;\n  overflow: hidden;\n}\n\ntrip-tile {\n  height: 100%;\n  position: absolute;\n}", ""]);

